import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams, useLocation } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import { SUPPORTED_LANGS } from "./i18n";
import { Layout } from "./components/Layout";
import HomePage from "./pages/HomePage";
import TechnologyPage from "./pages/TechnologyPage";
import SolutionsPage from "./pages/SolutionsPage";
import PartnershipPage from "./pages/PartnershipPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import { PrivacyPage, TermsPage } from "./pages/LegalPages";

const preferredLang = () => {
  const stored = localStorage.getItem("nortis-lang");
  return SUPPORTED_LANGS.includes(stored) ? stored : "en";
};

const RootRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`/${preferredLang()}${search}`} replace />;
};

const LocalizedApp = () => {
  const { lang } = useParams();
  const location = useLocation();

  if (!SUPPORTED_LANGS.includes(lang)) {
    return <Navigate to={`/${preferredLang()}${location.pathname}${location.search}`} replace />;
  }

  return (
    <LanguageProvider lang={lang}>
      <Layout>
        <Routes>
          <Route index element={<HomePage />} />
          <Route path="odf-technology" element={<TechnologyPage />} />
          <Route path="solutions" element={<SolutionsPage />} />
          <Route path="partnerships" element={<PartnershipPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="terms" element={<TermsPage />} />
          <Route path="*" element={<Navigate to={`/${lang}`} replace />} />
        </Routes>
      </Layout>
    </LanguageProvider>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/:lang/*" element={<LocalizedApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
